





































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { StreamItems } from '@/modules/firebase/firestore'


@Component
export default class AddItemModal extends Vue {
    @Prop() value!: boolean
    db = new StreamItems()
    formValid = true
    errorMessage = ''
    loading = false
    inputs: { note: string; value: string } = {
        note: '',
        value: ''
    }

    // reset() {
    //     (this.$refs.form as HTMLFormElement).reset()
    // }

    // resetValidation() {
    //     console.info((this.$refs.form as HTMLFormElement).resetValidation())
    // }

    async addItem() {
        if ((this.$refs.form as HTMLFormElement).validate() && !this.loading) {
            this.loading = true
            await this.db.addFromInputs(this.inputs.value, this.inputs.note)
            this.toggleModal(false)
            this.loading = false
        }
    }

    @Emit('input')
    toggleModal(value: boolean): boolean {
        return value
    }
}
